import { derived } from "svelte/store";
import { getCurrencyBalance } from "../dal/wax";
import { account, unclaimedAetherStore } from "../domain/store";
import * as Price from "./Price";
export const currencyBalance = derived([account, unclaimedAetherStore], ([$account, $unclaimedAether], set) => {
    getCurrencyBalance($account).then((balance) => {
        const calculated = calcBalances(balance || []);
        if ($unclaimedAether && $unclaimedAether > 0) {
            calculated.push({
                amount: $unclaimedAether,
                currency: "UNCLAIMED AETHER",
                usdAmount: 0.0,
                waxAmount: 0.0,
            });
        }
        set(calculated);
    });
}, []);
export function getAccountBalances(currencyBalance, pricesInWax, waxPrice) {
    const balances = calcPrices(currencyBalance, pricesInWax, waxPrice);
    const total = getTotals(balances);
    return {
        balances,
        wax: total.wax,
        usd: total.usd,
    };
}
export function calcBalances(balances) {
    return balances.map((balance) => {
        const split = balance.split(" ");
        return {
            currency: split[1],
            amount: Number.parseFloat(split[0]),
            waxAmount: 0,
            usdAmount: 0,
        };
    });
}
export function calcPrices(balances, prices, waxPrice) {
    return balances.map((blc) => {
        const price = Price.getPrice(prices, blc.currency);
        const waxAmount = blc.amount * price;
        const usdAmount = waxAmount * waxPrice;
        return Object.assign(Object.assign({}, blc), { waxAmount,
            usdAmount });
    });
}
export function getTotals(balances) {
    let totalWax = 0;
    let totalUsd = 0;
    balances.forEach(({ waxAmount, usdAmount }) => {
        totalWax += waxAmount;
        totalUsd += usdAmount;
    });
    return { wax: totalWax, usd: totalUsd };
}
